import { useGetDirectPayMaterialVendorsQuery } from '@/services/organizations';

import { DirectPayMaterialVendorAliasOptions, DirectPayMaterialVendorDisplayNameOptions } from 'types';

/**
 * Renders the " with <Vendor> (<Sub-Company>)" suffix for a direct pay opt-in/opt-out
 * activity entry. The vendor alias maps to a display name statically; the sub-company id is
 * resolved to its name via the vendor catalog (same source the opt-in modal uses), falling
 * back to the raw id. Renders nothing for legacy events that carry no vendor.
 */
export const DirectPayVendorLabel = ({
  alias,
  subCompanyId,
}: {
  alias?: DirectPayMaterialVendorAliasOptions;
  subCompanyId?: string;
}) => {
  const { data: directPayMaterialVendors } = useGetDirectPayMaterialVendorsQuery(undefined, {
    skip: !alias || !subCompanyId,
  });

  if (!alias) return null;

  const vendorName = DirectPayMaterialVendorDisplayNameOptions[alias] ?? alias;

  const subCompanyName = subCompanyId
    ? (directPayMaterialVendors?.materialVendors
        ?.find((vendor) => vendor.directPayMaterialVendorAlias === alias)
        ?.subCompanies?.find((subCompany) => subCompany.id === subCompanyId)?.name ?? subCompanyId)
    : undefined;

  return (
    <>
      {' '}
      with <strong>{vendorName}</strong>
      {subCompanyName ? (
        <>
          {' '}
          (<strong>{subCompanyName}</strong>)
        </>
      ) : null}
    </>
  );
};

export default DirectPayVendorLabel;
